import { createContext, useContext } from 'react';

export const EmojiPickerContext = createContext(null);

export const EmojiPickerProvider = EmojiPickerContext.Provider;

export const useEmojiPickerContext = () => useContext(EmojiPickerContext);
